// @flow
import React, { Fragment, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import sortBy from 'ramda/es/sortBy'
import groupBy from 'ramda/es/groupBy'
import pipe from 'ramda/es/pipe'
import toPairs from 'ramda/es/toPairs'
import path from 'ramda/es/path'

import RowLayout, { Header, Space, HeaderContent, RowLayoutContent } from 'app/common/layouts/RowLayout'
import { Supplier } from 'app/dataTypes/cabinet/support/SupportTypes'

import groupSchedule from './group-shedule'
import styles from './help-contacts.module.scss';

/**
 *  Подраздел помощи отображающий контакты и расписание если есть
 */

type Props = {
  supplier: Supplier,
}

const HelpSuppliers = ({ supplier }: Props) => {
  const { schedule, contacts, schools } = supplier
  const { t } = useTranslation('help')

  const arrangedContacts: any = useMemo(() => pipe(
    groupBy((item: { kind: string }) => item.kind),
    toPairs,
    sortBy(path<any>([1, 0, 'position']))
  )(contacts), [contacts])

  const arrangedSchedule = useMemo(() => (
    groupSchedule(schedule)
  ), [schedule])

  const scheduleEnabled = !!arrangedSchedule.usualDays
  const schoolTitle = schools.map(school => `«${school.title}»`).join(', ')

  return (
    <Fragment>
      <Space />
      <RowLayout paddingfree>
        <HeaderContent><Header>{t('support_supplier_contacts_header', { schoolTitle })}</Header></HeaderContent>
        <RowLayoutContent>
          <ul className={styles.itemsList}>
            {arrangedContacts.map(([kind, values]) => {
              if (kind) {
                return (
                  <li key={kind}>
                    <div className={styles.itemHeader}>{`${kind}:`}</div>
                    {values.map(({ value }) => (
                      <div key={value}>{value}</div>
                    ))}
                  </li>
                )
              }
              return null
            })}

            {scheduleEnabled
              && <li key="schedule">
                <div className={styles.itemHeader}>
                  {`${t('support_schedule_header', 'Часы работы')}:`}
                </div>

                {arrangedSchedule.usualDays.map(({ title, openClose, lunch }) => (
                  <Fragment key={title}>
                    <div>
                      {`${title}: ${openClose}`}
                    </div>
                    {lunch
                      && <div className={styles.ext}>
                        {`${t('support_schedule_break_header', 'Перерыв')}: ${lunch}`}
                      </div>}
                  </Fragment>
                ))}

                {arrangedSchedule.vacancy
                  && <div className={styles.ext}>
                    {/,/.test(arrangedSchedule.vacancy)
                      ? <span>{`${t('support_schedule_weekend_header', 'Выходные')}: `}</span>
                      : <span>{`${t('support_schedule_weekend_header_solo', 'Выходной')}: `}</span>}
                    {arrangedSchedule.vacancy}
                  </div>}
              </li>}
          </ul>
        </RowLayoutContent>
      </RowLayout>
    </Fragment>
  )
}

export default HelpSuppliers
